// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2p7Yf","validationTips":"StatementDescriptor_validationTips__1ceGN"};